import { Swiper } from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';

const sliders = document.querySelectorAll('.block-related-posts .swiper');

if (sliders.length > 0) {
	sliders.forEach((slider) => {
		const cardCount = parseInt(slider?.dataset?.cardCount ?? 4);
		const cardsPerRow = parseInt(slider?.dataset?.cardsPerRow ?? 4);
		const mobileSlidesPerView = 1;
		let tabletSlidesPerView = 2;
		let desktopSmallSlidesPerView = 3;
		let desktopSlidesPerView = cardsPerRow;

		if (cardCount === 1) {
			desktopSlidesPerView = 2;
			desktopSmallSlidesPerView = 2;
			tabletSlidesPerView = 2;
		} else if (cardCount === 2) {
			desktopSlidesPerView = 2;
			desktopSmallSlidesPerView = 2;
		} else if (cardCount === 3) {
			if (desktopSlidesPerView > 3) {
				desktopSlidesPerView = 3;
			}
		}

		if (slider.querySelector('.location-post-card')) {
			tabletSlidesPerView = 1;
			desktopSmallSlidesPerView = 1;
			desktopSlidesPerView = 1;
		}

		const paginationElement =
			slider.parentElement.querySelector('.swiper-pagination');

		const settings = {
			loop: false,
			grabCursor: true,
			slidesPerView: mobileSlidesPerView,
			centeredSlides: false,
			spaceBetween: 8,
			modules: [A11y, Navigation, Pagination],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				prevEl: slider.parentElement.querySelector(
					'.swiper-button-prev'
				),
				nextEl: slider.parentElement.querySelector(
					'.swiper-button-next'
				),
			},
			pagination: {
				el: paginationElement,
				clickable: false,
				dynamicBullets: false,
			},
			breakpoints: {
				576: {
					slidesPerView: tabletSlidesPerView,
					spaceBetween: 8,
				},
				768: {
					slidesPerView: tabletSlidesPerView,
					spaceBetween: 24,
				},
				1200: {
					slidesPerView: desktopSmallSlidesPerView,
					spaceBetween: 32,
				},
				1400: {
					slidesPerView: desktopSlidesPerView,
					spaceBetween: 32,
				},
			},
		};

		new Swiper(slider, settings);
	});
}
